import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
 
import { AuthenticationService } from '../services/auth.service';
 
@Injectable({ providedIn: 'root' })
export class AuthGuard {
    constructor(
        private router: Router,
        private authenticationService: AuthenticationService
    ) { }
 
    canActivate(state: RouterStateSnapshot) {
        const currentUser = this.authenticationService.currentUserValue;
        if (currentUser) {
            // logged in so return true
            return true;
        }
        // check if user data is in storage is logged in via API.
        if (localStorage.getItem('currentUser')) {
            return true;
        }
 
        // not logged in so redirect to login page with the return url
        this.router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
        return false;
    }
}